import { render, staticRenderFns } from "./SGVideo.vue?vue&type=template&id=51712275&scoped=true&"
import script from "./SGVideo.vue?vue&type=script&lang=ts&"
export * from "./SGVideo.vue?vue&type=script&lang=ts&"
import style0 from "./SGVideo.vue?vue&type=style&index=0&id=51712275&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51712275",
  null
  
)

export default component.exports